import { render, staticRenderFns } from "./LPBInfoInvalid.vue?vue&type=template&id=789d8060&scoped=true&"
import script from "./LPBInfoInvalid.vue?vue&type=script&lang=js&"
export * from "./LPBInfoInvalid.vue?vue&type=script&lang=js&"
import style0 from "./LPBInfoInvalid.vue?vue&type=style&index=0&id=789d8060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d8060",
  null
  
)

export default component.exports